(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meat-dudes"] && !Shopify.designMode) return;
  try {
    
  class MeatDudesPlayer extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.cover = this.querySelector('.meat-dudes__cover');
      if (!this.video || !this.cover) return;

      this.durationLabel = this.querySelector('[data-duration]');
      this.video.addEventListener('loadedmetadata', () => this.showDuration());
      if (this.video.readyState >= 1) this.showDuration();

      this.cover.addEventListener('click', () => this.start());
      this.video.addEventListener('play', () => this.hideCover());
    }

    showDuration() {
      const duration = this.video.duration;
      if (this.durationLabel && this.dataset.showDuration === 'true' && isFinite(duration)) {
        this.durationLabel.textContent = ' · ' + Math.max(1, Math.round(duration / 60)) + ' min';
      }
    }

    start() {
      this.video.muted = false;
      this.video.play();
      this.hideCover();
      this.video.focus({ preventScroll: true });
    }

    hideCover() {
      this.cover.classList.add('is-hidden');
      this.cover.setAttribute('tabindex', '-1');
    }
  }

  if (!customElements.get('meat-dudes-player')) {
    customElements.define('meat-dudes-player', MeatDudesPlayer);
  }

  } catch(e) { console.error(e); }
})();
})();
